// @flow

// stripe clientside validation https://js.stripe.com/v2
/* eslint-disable */
const __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
const defaultFormat = /(\d{1,4})/g;
const cards = [
  {
  //   type: 'maestro',
  //   patterns: [5018, 502, 503, 506, 56, 58, 639, 6220, 67],
  //   format: defaultFormat,
  //   length: [12, 13, 14, 15, 16, 17, 18, 19],
  //   cvcLength: [3],
  //   luhn: true
  // }, {
  //   type: 'forbrugsforeningen',
  //   patterns: [600],
  //   format: defaultFormat,
  //   length: [16],
  //   cvcLength: [3],
  //   luhn: true
  // }, {
  //   type: 'dankort',
  //   patterns: [5019],
  //   format: defaultFormat,
  //   length: [16],
  //   cvcLength: [3],
  //   luhn: true
  // }, {
    type: 'visa',
    patterns: [4],
    format: defaultFormat,
    length: [13, 16],
    cvcLength: [3],
    luhn: true
  }, {
    type: 'mastercard',
    patterns: [51, 52, 53, 54, 55, 22, 23, 24, 25, 26, 27],
    format: defaultFormat,
    length: [16],
    cvcLength: [3],
    luhn: true
  },/* {*/
  //   type: 'amex',
  //   patterns: [34, 37],
  //   format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
  //   length: [15],
  //   cvcLength: [3, 4],
  //   luhn: true
  // }, {
  //   type: 'dinersclub',
  //   patterns: [30, 36, 38, 39],
  //   format: /(\d{1,4})(\d{1,6})?(\d{1,4})?/,
  //   length: [14],
  //   cvcLength: [3],
  //   luhn: true
  // }, {
  //   type: 'discover',
  //   patterns: [60, 64, 65, 622],
  //   format: defaultFormat,
  //   length: [16],
  //   cvcLength: [3],
  //   luhn: true
  // }, {
  //   type: 'unionpay',
  //   patterns: [62, 88],
  //   format: defaultFormat,
  //   length: [16, 17, 18, 19],
  //   cvcLength: [3],
  //   luhn: false
  // }, {
  //   type: 'jcb',
  //   patterns: [35],
  //   format: defaultFormat,
  //   length: [16],
  //   cvcLength: [3],
  //   luhn: true
  // }
];

// stripe luhnCheck https://github.com/stripe/jquery.payment/blob/master/lib/jquery.payment.js#L121
function luhnCheck(num:string) {
  var digit, digits, odd, sum, _i, _len;
  odd = true;
  sum = 0;
  digits = (num + '').split('').reverse();
  for (_i = 0, _len = digits.length; _i < _len; _i++) {
    digit = digits[_i];
    digit = parseInt(digit, 10);
    if ((odd = !odd)) {
      digit *= 2;
    }
    if (digit > 9) {
      digit -= 9;
    }
    sum += digit;
  }
  return sum % 10 === 0;
};

function cardFromNumber (num:string) {
  var card, p, pattern, _i, _j, _len, _len1, _ref;
  num = (num + '').replace(/\D/g, '');
  for (_i = 0, _len = cards.length; _i < _len; _i++) {
    card = cards[_i];
    _ref = card.patterns;
    for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
      pattern = _ref[_j];
      p = pattern + '';
      if (num.substr(0, p.length) === p) {
        return card;
      }
    }
  }
};

export function validateCardNumber(num: string|number):boolean {
  var card, _ref;
  num = (num + '').replace(/\s+|-/g, '');
  if (!/^\d+$/.test(num)) {
    return false;
  }
  card = cardFromNumber(num);
  if (!card) {
    return false;
  }
  return (_ref = num.length, __indexOf.call(card.length, _ref) >= 0) && (card.luhn === false || luhnCheck(num));
}

function routingChecksum(a: string):boolean{
  var b, c, d, e, f, g;
  for (d = 0, b = (a + "").split(""), g = [0, 3, 6], e = 0, f = g.length; e < f; e++) c = g[e], d += 3 * parseInt(b[c]), d += 7 * parseInt(b[c + 1]), d += parseInt(b[c + 2]);
  return 0 !== d && d % 10 === 0;
}

function trim(a: string|number): string{
  const pattern = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g
  return null === a ? "" : (a + "").replace(pattern, "")
}

export function validateRoutingNumber(b: string|number, d:string= 'US'): boolean{
  switch (b = trim(b), d) {
    case "US":
      return /^\d+$/.test(b) && 9 === b.length && routingChecksum(b);
    // case "CA":
    //   return /\d{5}\-\d{3}/.test(b) && 9 === b.length;
    default:
      return !0
  }
}

export function validateAccountNumber(b: string|number, c:string = 'US') {
  switch (b = trim(b), c) {
    case "US":
      return /^\d+$/.test(b) && b.length >= 1 && b.length <= 17;
    default:
      return !0
  }
}

/* eslint-enable */

export const SSN = /^(?!\b(\d)\1+-(\d)\1+-(\d)\1+\b)(?!123-45-6789|219-09-9999|078-05-1120)(?!666|000|9\d{2})\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$/; // eslint-disable-line
export const redactedSSN = /^xxx-?xx-?\d{4}$/;
export const phoneNumber = /^\(?([2-9]\d{2})\)?-? ?(\d{3})-? ?(\d{4})$/;
export const email = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?\.(?:[a-z]{2,}|xn--[a-z0-9]+)$/i; // eslint-disable-line
